import { createReducer } from "@reduxjs/toolkit";
import { ErrorAction, errorHandler } from "utils/error";
import { toast } from "react-toastify";
import { API_GET_ALL_ROADS_SUCCESS, API_GET_ALL_ROADS, API_GET_ALL_ROADS_FAIL } from "actions/road";

const initialState = {
	list: {
		data: [],
		loading: false,
	},
	current: {
		data: {},
		loading: false,
	},
};

const round = createReducer(initialState, {
	/** GET APPOINTMENTS BY NURSE **/
	[API_GET_ALL_ROADS]: (state, action) => {
		state.list.loading = true;
	},
	[API_GET_ALL_ROADS_FAIL]: (state, action) => {
		errorHandler("Synchronisation tournée", ErrorAction.UPDATE, action.error);
		state.list.loading = false;
	},
	[API_GET_ALL_ROADS_SUCCESS]: (state, action) => {
		toast.success("Synchronisation réussie");
		state.list.loading = false;
		state.list.data = action.payload.data;
	},
});

export default round;
